

<p-drawer header="&nbsp;" [(visible)]="visible" position="full" [blockScroll]="true" #drawerRef>
    <ng-template #headless>

        <p-selectbutton class="mobile-readmore-state-toggler" [unselectable]="false" (onOptionClick)="handleOptionChange($event)" [options]="stateOptions" [(ngModel)]="stateValue" optionLabel="label" optionValue="value" aria-labelledby="basic" />


        <p-button class="readmore-close-button" [rounded]="true" icon="" text="true" (click)="handleOnHide($event)" [attr.data-testid]="'room-drawer-close'">
            <span class="material-symbols-outlined">
                close
            </span>
        </p-button>

        @if (roomData) {
            <div class="row av-readmore-content">
                <div class="col-12 col-lg-6" [class.readmore-mobile-hidden]="stateValue == 'details'">
                    <app-image-gallery1 #galleryRef context="readmore" [preventLightbox]="true" [roomCode]="roomData.roomrates[0].room.roomCode" [hotelCode]="hotelCode"></app-image-gallery1>
                </div>
                <div class="col-12 col-lg-6" [class.readmore-mobile-hidden]="stateValue == 'images'">
                    <div class="room-data">
                        <div class="row">
                            <div class="col-10">
                                <h2 class="room-name" [attr.data-testid]="'room-drawer-name'">{{roomData.roomrates[0].room.pim?.name}}</h2>
                            </div>
                            @if(getCategoryName(roomData.roomrates[0].room)) {
                                <div class="col-2">
                                    <div class="room-category-tag">{{getCategoryName(roomData.roomrates[0].room)}}</div>
                                </div>
                            }

                        </div>

                        <div class="amenities">
                            @for (amenity of roomData.roomrates[0].room.pim?.amenities; track $index) {
                                <div  class="amenity">
                                    @if (amenity == 'tv') {
                                        <span class="amenity-icon">
                                            <span class="material-symbols-outlined">tv</span>
                                        </span>
                                        <span class="amenity-text">{{"av.Television"|translate}}</span>
                                    }
                                    @if (amenity == 'kingbed') {
                                        <span class="amenity-icon">
                                            <span class="material-symbols-outlined">king_bed</span>
                                        </span>
                                        <span class="amenity-text">{{"av.KingBed"|translate}}</span>
                                    }
                                    @if (amenity == 'twin') {
                                        <span class="amenity-icon">
                                            <span class="material-symbols-outlined">single_bed</span>
                                            <span class="material-symbols-outlined">single_bed</span>
                                        </span>
                                        <span class="amenity-text">{{"av.TwoSingleBeds"|translate}}</span>
                                    }
                                    @if (amenity == 'ac') {
                                        <span class="amenity-icon">
                                            <span class="material-symbols-outlined">ac_unit</span>
                                        </span>
                                        <span class="amenity-text">{{"av.AC"|translate}}</span>
                                    }
                                </div>
                            }
                        </div>

                        <div class="room-description" [innerHTML]="roomData.roomrates[0].room.pim?.longDescription" [attr.data-testid]="'room-drawer-description'"></div>

                        @if (roomData.roomrates[0].room.pim?.genericRoomTexts) {
                            <div class="generic-room-texts">
                                <h5 [innerHTML]="roomData.roomrates[0].room.pim?.genericRoomTexts.title"></h5>
                                <div [innerHTML]="roomData.roomrates[0].room.pim?.genericRoomTexts.description"></div>
                            </div>
                        }


                    </div>
                </div>
            </div>
        }
    </ng-template>
</p-drawer>

